import React from 'react';
import { Chart } from 'react-google-charts';
import styled from 'styled-components';

const PieChart = styled.div`
  text-align: left;
  border: 1px solid #cccccc;
  border-radius: 0.375rem;
  padding: 2rem;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const DownloadButton = styled.button`
  padding: 0.5rem 1rem;
  background-color: #0a819f;
  color: #ffffff;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
`;

const ChartPie = ({ pieChartData, billName }) => {
  const convertObjectToArray = (data) => {
    const result = [['name', 'time']]; // Initialize with headers

    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const { name, time } = data[key];
        result.push([name, time]);
      }
    }

    return result;
  };

  const pieChartDataArray = convertObjectToArray(pieChartData);

  const convertToCSV = (data) => {
    return data.map((row) => row.join(',')).join('\n');
  };

  const downloadCSV = () => {
    const csv = convertToCSV(pieChartDataArray);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `Bill ${billName} Speaker Participation.csv`;
    link.click();
    URL.revokeObjectURL(link.href);
  };

  return (
    <PieChart>
      <Chart
        width={'auto'}
        height={'440px'}
        chartType="PieChart"
        loader={<div>Loading Chart</div>}
        data={pieChartDataArray}
        options={{
          chartArea: {
            height: '80%',
            top: '0%',
            width: '100%',
            left: '0',
          },
          sliceVisibilityThreshold: 0.05,
          colors: [
            '#494490',
            '#1B67AE',
            '#EBBA54',
            '#D35F4F',
            '#9F77BF',
            '#90BE77',
            '#E58F40',
            '#CCCCCC',
          ],
          legend: {
            position: 'bottom',
            alignment: 'center',
          },
        }}
      />
      <DownloadButton onClick={downloadCSV}>Download Chart Data</DownloadButton>
    </PieChart>
  );
};
export default ChartPie;
